import React from "react";
import TradingViewWidget from "./TradingViewWidget";

// Real-time ticker tape powered by TradingView.
const config = {
  symbols: [
    { proname: "OANDA:XAUUSD", title: "Gold" },
    { proname: "FX:EURUSD", title: "EUR/USD" },
    { proname: "FX:GBPUSD", title: "GBP/USD" },
    { proname: "FX:USDJPY", title: "USD/JPY" },
    { proname: "FOREXCOM:NSXUSD", title: "NAS100" },
    { proname: "FOREXCOM:DJI", title: "US30" },
    { proname: "BINANCE:BTCUSDT", title: "BTC/USDT" },
    { proname: "TVC:DXY", title: "DXY" },
  ],
  showSymbolLogo: true,
  isTransparent: true,
  displayMode: "adaptive",
  colorTheme: "dark",
  locale: "en",
};

const TickerTape = () => (
  <div className="ws-ticker-tv">
    <TradingViewWidget
      scriptSrc="https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js"
      config={config}
    />
  </div>
);

export default TickerTape;
